import { type FC } from 'react';

import { cn } from '@/utils';

const PanelWrapper: FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, className, ...props }) => {
  return (
    <div
      {...props}
      className={cn('bg-foreground flex items-center justify-center rounded-2xl p-2 shadow-lg sm:p-4', className)}
    >
      {children}
    </div>
  );
};

export default PanelWrapper;
